import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5486_2334)">
      <rect
        width="24"
        height="24"
        rx="4"
        transform="matrix(-1 0 0 1 24.0005 0)"
        fill="url(#paint0_linear_5486_2334)"
      />
      <g filter="url(#filter0_d_5486_2334)">
        <path
          d="M13.5974 7.30273H16.6977V10.4342V13.5657V16.6972H13.5974H13.5662H12.8146V13.5658H11.2175V16.6972H10.4347H7.30322V13.5658V10.4342V7.30273H10.4346H11.2175V10.4342H12.8146V7.30273H13.5662H13.5974Z"
          fill="black"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.08472 4.08423H19.9163V10.3679H18.3016V5.69892H5.69941V18.3011H18.3016V13.5904H19.9163V19.9158H4.08472V4.08423Z"
        fill="black"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5486_2334"
        x="-16.3901"
        y="-11.6519"
        width="56.7812"
        height="56.7811"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.73867" />
        <feGaussianBlur stdDeviation="11.8467" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5486_2334"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5486_2334"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5486_2334"
        x1="22.5462"
        y1="1.45378"
        x2="1.28044"
        y2="22.7196"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEB169" />
        <stop offset="0.397256" stop-color="#F87ADD" />
        <stop offset="0.655673" stop-color="#E667F9" />
        <stop offset="1" stop-color="#7F4AD1" />
      </linearGradient>
      <clipPath id="clip0_5486_2334">
        <rect width="24" height="24" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
